import * as o from "react";
import i from "../lib/IconBase.es.js";
import n from "../defs/ArrowLineUpRight.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(i, { ref: t, ...e, weights: n }));
r.displayName = "ArrowLineUpRightIcon";
const p = r;
export {
  p as ArrowLineUpRight,
  r as ArrowLineUpRightIcon
};
